var thumbs = new Swiper(".slider-thumbnail.swiper-container", {
  slidesPerView: "auto",
  spaceBetween: 10,
  centeredSlides: false,
  loop: false,
});

var slider = new Swiper(".slider_slide.swiper-container", {
  slidesPerView: 1,
  centeredSlides: false,
  loop: true,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  thumbs: {
    swiper: thumbs,
  },
});


slider.on("slideChange", function () {
  if (window.innerWidth >= 768) {
    thumbs.slideTo(slider.realIndex);
  }
});

Fancybox.bind("[data-fancybox]", {
  autoplay: true,
  Toolbar: false,
  closeButton: "top",
});



$(document).ready(function () {

  
  // footer accordian mobile

  $(".footr--tabs--collab").click(function () {
    $(this).siblings(".list-unstyled").toggleClass("ctm_hide_mob_menu");

    const span = $(this).find("span");
    const currentText = span.text();
    span.text(currentText === "+" ? "-" : "+");
  });

  $(".header__icon--search").on("click", () => $(".product-detail-tab").hide());
  $(".modal__close-button.link").on("click", () =>
    $(".product-detail-tab").show()
  );
  $(".modal-overlay").on("click", (e) => {
    if (e.target === e.currentTarget) $(".product-detail-tab").show();
  });


  
  // megamenu custom js

  
  $(".inner--ctm--menu .link--collection").hover(function () {
    $(this).addClass("cusotm--first--child");
    $(this).siblings(".link--collection").removeClass("cusotm--first--child");
    var link_value = $(this).attr("data--link");

    var content_product = $(this)
      .closest(".ctm--menu--part")
      .find(".inner_products_ctm");
    var links_product = $(this)
      .closest(".ctm--menu--part")
      .find(".menu-action");

    $(content_product).each(function () {
      var productData = $(this).attr("data--content");

      if (link_value === productData) {
        $(this).addClass("first--element");
      } else {
        $(this).removeClass("first--element");
      }
    });

    $(links_product).each(function () {
      var linkData = $(this).attr("data--content");

      if (link_value === linkData) {
        $(this).addClass("first--element");
      } else {
        $(this).removeClass("first--element");
      }
    });
  });

  
  $(".mega-menu").hover(
    function () {
      $(this).attr("open", "true");
      $(".product-detail-tab").css("z-index", "2");
    },
    function () {
      $(this).removeAttr("open");
      $(".product-detail-tab").css("z-index", "3");
    }
  );

  
  $(".tab--links").click(function () {
    var activeTab = $(this).attr("data-sections");
    $(this).addClass("active-link");
    $(this).siblings(".tab--links").removeClass("active-link");
    var parentElement = $(this)
      .closest(".tab_headings")
      .siblings(".section_tab_content");
    var childElement = $(parentElement).find(".tabs--contents--ctm");

    $(childElement).each(function () {
      var dataTabContent = $(this).attr("data__content");

      if (activeTab === dataTabContent) {
        $(this).addClass("active--tab");
      } else {
        $(this).removeClass("active--tab");
      }
    });
  });

  
  $(".add--in--cart").click(function () {
    $(".ctm--trigg-btn").trigger("click");
  });

  

  $(".tab-content-mt").hide();
  // $(".tabs-heading_mt").first().addClass("active").siblings(".tab-content-mt").show();
  $(".tabs-heading_mt").click(function () {
    var $tabContent = $(this).siblings(".tab-content-mt");
    $tabContent.toggle();
    $(this).find("svg").toggleClass("svg_tranform");
    // $(".tabs-heading_mt").not(this).removeClass("active");
    $(this).toggleClass("active");
    // $(".tab-content-mt").not($tabContent).hide();
  });
});



$(window).on("scroll", function () {
  if ($(this).scrollTop() > 200) {
    $(".back-top").css("opacity", "1");
  } else {
    $(".back-top").css("opacity", "0");
  }
  
});

$(".back-top").click(function () {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
});


$('.clos_announcement_bar').click(function () {
  $(this).closest('.announcement-bar-section').fadeOut(300);
});
